<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-session-expired-page">
    Session expired...
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'logout',  
  created() {
    setInterval(() => {
      if(!window.opener) {
        window.close();
      }
    }, 1000);
  }
});
</script>

<style lang="scss">
.wy-session-expired-page {
  padding: 40px;
  text-align: center;
}
</style>